import React, { useEffect, useState } from 'react'
import { DialogContent,DialogContentText, DialogActions, Button, DialogTitle, useTheme, useMediaQuery } from '@mui/material';
import ConfirmDialog from './ConfirmDialog';
import { getLocale } from '../../Helper/i18n';

function ConfirmLocation({...props}){
    const theme = useTheme()
    const [openAlert,setOpenAlert]=useState(false)
    const [localeText, setLocaleText] = useState()
    const matches = useMediaQuery(theme.breakpoints.down('md'));

    useEffect(()=>{
        getLocale({ translation: 'en', module: 'common' }).then(data => setLocaleText(data));
        geoFindMe()
    },[])
    function geoFindMe() {
         if (!navigator.geolocation) {
            console.log("Geolocation is not supported by your browser");
            document.getElementById("error").innerHTML = localeText?.confirmLocation
            return;
        }
       
        setTimeout(()=>navigator.geolocation.getCurrentPosition(success, showError),3000);
    }
    function success(position) {
        var latitude = position.coords.latitude;
        var longitude = position.coords.longitude;
        props.closepopup(latitude,longitude)
    }
    function showError(error) {
        switch(error.code) {
            case error.PERMISSION_DENIED:
            console.log("User denied the request for Geolocation.")
            break;
            case error.POSITION_UNAVAILABLE:
                console.log("Location information is unavailable.")
            break;
            case error.TIMEOUT:
                console.log("The request to get user location timed out.")
            break;
            case error.UNKNOWN_ERROR:
                console.log("An unknown error occurred.")
            break;
        }
        props.closepopup()
        }
    return <><ConfirmDialog fullWidth={true} maxWidth={"sm"} style={{padding:"0px",margin:"0px",borderRadius:"10px",background:"transparent"}} /* fullScreen */ {...props}>
            <DialogContent style={{padding:"0px",margin:"0px",background:"#a87f3c"}}>
                   <img style={{width:"100%"}} src="images/icon_info.svg" />
            </DialogContent>
            <img style={{position: "fixed",top: "175px",left: "350px",/* animation:"ArrowAnimate 800ms infinite" */}} src="images/icon_info.svg" />

        </ConfirmDialog> 
        </>   
}

export default ConfirmLocation;